import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Loader from "../../components/common/Loader";
import Footer from "../../components/common/Footer";
import Menu from "../../components/common/Menu";
import Navbar from "../../components/common/Navbar";
import StartButton from "../../components/home/StartButton";
import { usePageLoader } from "../../hooks/usePageLoader";
import { tempeFabricationClientWrapper } from "../../services/tempeFabricationClientWrapper";

const CheckoutExpired: React.FC = () => {
  usePageLoader();
  const navigate = useNavigate();
  const location = useLocation();

  // Cancel payment intent on mount (courtesy call to backend)
  useEffect(() => {
    // Try to get payment intent ID from navigation state
    const paymentIntentId = location.state?.paymentIntentId;

    if (paymentIntentId) {
      console.log('[CheckoutExpired] Cancelling payment intent:', paymentIntentId);
      // Fire and forget - errors are logged but not thrown
      tempeFabricationClientWrapper.cancelPaymentIntent(paymentIntentId);
    } else {
      console.log('[CheckoutExpired] No payment intent ID found in navigation state, skipping cancellation');
    }
  }, [location.state]);

  return (
    <>
      <Helmet>
        <title>Checkout Expired | Tempe Fabrication</title>
        <link rel="stylesheet" type="text/css" href="/home/assets/css/home_1_style.css" />
        <link rel="stylesheet" type="text/css" href="/innerpages/assets/css/innerpages.css" />
      </Helmet>
      <div className="inner-pages-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar currentPage="products" />

          <header className="tc-inner-header-style1">
            <div className="container">
              <div className="info col-lg-8">
                <h2 className="js-title">Checkout Expired</h2>
              </div>
            </div>
          </header>

          <section className="tc-product-detail-section" style={{ padding: "80px 0" }}>
            <div className="container">
              <div style={{
                backgroundColor: "#f9f9f9",
                padding: "60px 40px",
                borderRadius: "8px",
                textAlign: "center",
                maxWidth: "700px",
                margin: "0 auto",
              }}>
                {/* Warning Icon */}
                <div style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "#ff9800",
                  margin: "0 auto 30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                </div>

                <h1 style={{
                  fontSize: "32px",
                  fontWeight: "600",
                  marginBottom: "15px",
                }}>
                  Checkout Session Expired
                </h1>

                <p style={{
                  fontSize: "16px",
                  color: "#666",
                  marginBottom: "30px",
                  lineHeight: "1.6",
                }}>
                  Your checkout session has expired for security reasons. Don't worry - your cart items are still saved.
                  Please return to your cart and try checking out again.
                </p>

                <div style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}>
                  <button
                    onClick={() => navigate("/products")}
                    className="butn border rounded-pill hover-bg-black"
                    style={{
                      padding: "12px 30px",
                      color: "#333",
                    }}
                  >
                    <span>Continue Shopping</span>
                  </button>

                  <button
                    onClick={() => navigate("/")}
                    className="butn border rounded-pill hover-bg-black bg-orange1 text-white"
                    style={{
                      padding: "12px 30px",
                    }}
                  >
                    <span>Back to Home</span>
                  </button>
                </div>

                <div style={{
                  marginTop: "40px",
                  paddingTop: "30px",
                  borderTop: "1px solid #ddd",
                }}>
                  <p style={{
                    fontSize: "14px",
                    color: "#999",
                    marginBottom: "10px",
                  }}>
                    Need help with your order?
                  </p>
                  <a
                    href="/contact"
                    style={{
                      color: "var(--color-orange1)",
                      textDecoration: "none",
                      fontWeight: "500",
                    }}
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </section>

          <Footer />
        </div>
        <StartButton />
      </div>
    </>
  );
};

export default CheckoutExpired;
